import { parseURL, stringifyParsedURL, stringifyQuery, withTrailingSlash } from "ufo";
import { viewManifestReader } from "../internal/read-view-manifest.js";
export class RouteError extends Error {
    message;
    statusCode;
    constructor(message, statusCode) {
        super(message);
        this.message = message;
        this.statusCode = statusCode;
    }
}
export class RouteLoader {
    entries = new Map();
    components = new Map();
    appData = null;
    fetchImpl = (url, opts) => fetch(url, opts);
    processProps = null;
    id = Math.random();
    setFetchImpl(impl) {
        this.fetchImpl = impl;
    }
    setPropsPreprocessor(processProps) {
        this.processProps = processProps;
    }
    getKey(url) {
        const { pathname } = parseURL(url);
        return pathname.replace(/\/$/, "").replace(/^\//, "");
    }
    getPropsURL(pathname, opts) {
        const sampleUrl = env.client ? document.location.href : env.origin;
        const origin = parseURL(sampleUrl);
        let propsPath = withTrailingSlash(pathname);
        let query = {};
        if (env.serverless && env.client) {
            propsPath = "/_data/route" + propsPath;
            query = {};
            // query["_debug"] = opts.debug ? "1" : "0"
            // query["_props"] = opts.appData ? "all" : "1"
            // query["_ssr"] = "1"
        }
        else {
            query["_debug"] = opts.debug ? "1" : "0";
            query["_props"] = opts.appData ? "all" : "1";
            query["_ssr"] = "0";
        }
        return stringifyParsedURL({
            auth: origin.auth,
            host: origin.host,
            protocol: origin.protocol,
            pathname: propsPath,
            search: stringifyQuery(query),
        });
    }
    hasRouteData(pathname) {
        const cacheKey = this.getKey(pathname);
        return this.entries.has(cacheKey);
    }
    async loadRouteData(pathname, withAppData = false) {
        pathname = withTrailingSlash(pathname);
        const cacheKey = this.getKey(pathname);
        // Cached value?
        if (this.entries.has(cacheKey))
            return this.entries.get(cacheKey);
        const requestUrl = this.getPropsURL(pathname, {
            appData: withAppData,
            serverless: env.serverless,
            debug: env.dev,
        });
        const promise = this.fetchImpl(requestUrl)
            .then(async (response) => {
            if (response.redirected) {
                return { redirect: response.url };
            }
            let text = await response.text();
            if (this.processProps) {
                text = this.processProps(text);
            }
            try {
                const payload = JSON.parse(text);
                if (!payload.view && !payload.redirect) {
                    throw new RouteError(`Invalid route data for '${pathname}'`, 500);
                }
                return payload;
            }
            catch (err) {
                throw new RouteError(`JSON parse error for route '${pathname}':\n${err?.message}`, 500);
            }
        })
            .then(async (data) => {
            if (data.redirect) {
                const redirect = parseURL(data.redirect).pathname;
                data = await this.loadRouteData(redirect);
                data.canonical = redirect;
            }
            return data;
        })
            .then((data) => {
            this.entries.set(cacheKey, new Promise((resolve) => resolve(data)));
            return data;
        });
        this.entries.set(cacheKey, promise);
        return promise;
    }
    setAppData(appData) {
        this.appData = appData;
    }
    populateRouteData(pathname, data) {
        const cacheKey = this.getKey(pathname);
        this.entries.set(cacheKey, new Promise((resolve) => resolve(data)));
    }
    getRouteComponent(view) {
        return viewManifestReader.value[view];
    }
    get appComponent() {
        return viewManifestReader.value["_app"];
    }
}
